import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";

import { BrandProvider } from "./contexts/BrandContext";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import PublicLayout from "./components/PublicLayout";
import AdminLayout from "./components/AdminLayout";

import Home from "./pages/public/Home";
import Products from "./pages/public/Products";
import ProductDetail from "./pages/public/ProductDetail";
import Dealers from "./pages/public/Dealers";
import TechnicalService from "./pages/public/TechnicalService";
import Manuals from "./pages/public/Manuals";
import Firmware from "./pages/public/Firmware";
import Calibration from "./pages/public/Calibration";
import Software from "./pages/public/Software";
import Blog from "./pages/public/Blog";
import BlogDetail from "./pages/public/BlogDetail";
import Contact from "./pages/public/Contact";
import About from "./pages/public/About";

import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import AdminBrands from "./pages/admin/Brands";
import AdminCategories from "./pages/admin/Categories";
import AdminProducts from "./pages/admin/Products";
import AdminDealers from "./pages/admin/Dealers";
import AdminManuals from "./pages/admin/Manuals";
import AdminDownloads from "./pages/admin/Downloads";
import AdminBlog from "./pages/admin/BlogAdmin";
import AdminHomepage from "./pages/admin/HomepageContent";
import AdminPages from "./pages/admin/PagesContent";
import AdminSettings from "./pages/admin/Settings";
import AdminSubmissions from "./pages/admin/Submissions";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
        <AuthProvider>
          <BrandProvider>
            <Toaster theme="dark" position="top-right" richColors />
            <Routes>
              {/* Public site */}
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/urunler" element={<Products />} />
                <Route path="/urunler/:slug" element={<ProductDetail />} />
                <Route path="/bayiler" element={<Dealers />} />
                <Route path="/teknik-servis" element={<TechnicalService />} />
                <Route path="/kullanim-kilavuzlari" element={<Manuals />} />
                <Route path="/destek/firmware" element={<Firmware />} />
                <Route path="/destek/kalibrasyon" element={<Calibration />} />
                <Route path="/destek/yazilimlar" element={<Software />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogDetail />} />
                <Route path="/iletisim" element={<Contact />} />
                <Route path="/hakkimizda" element={<About />} />
              </Route>

              {/* Admin */}
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="brands" element={<AdminBrands />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="dealers" element={<AdminDealers />} />
                <Route path="manuals" element={<AdminManuals />} />
                <Route path="downloads" element={<AdminDownloads />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="homepage" element={<AdminHomepage />} />
                <Route path="pages" element={<AdminPages />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="submissions" element={<AdminSubmissions />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrandProvider>
        </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
